export const CATEGORIES_ACTIONS = {
  SET_CATEGORIES: 'category/SET_CATEGORIES'
}
